import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../Assets/javascripts/common/others/SharedDispatcher";

  var EXPAND_ACTIVE_CLASS = "Expand--active";

export default Backbone.View.extend({
    initialize: function () {
      this.isActive = this.$el.hasClass(EXPAND_ACTIVE_CLASS) || false;
    },

    events: {
      "click .js-OrdersExpand-control": "toggle"
    },

    toggle: function (event) {
      if (!$(event.target).is(".js-Track-link")) {
        event.preventDefault();
        event.stopPropagation();
      
        if (this.isActive) {
          this.isActive = false;
        } else {
          this.isActive = true;
        }

        this.render();
      }
    },

    render: function () {
      if (this.isActive) {
        this.$el.addClass('Expand--active');
        SharedDispatcher.trigger('expandView:show');

      } else {
        SharedDispatcher.trigger('expandView:hide');
        this.$el.removeClass('Expand--active');
      }

      if (this.$(".js-OrdersExpand-icon").length) {
        this.$(".js-OrdersExpand-icon").slice(0, 2).toggleClass("hidden");
      }
    }
  });
